import { render, staticRenderFns } from "./UserNewArrivalNoticeKeywordTable.vue?vue&type=template&id=6197bbd9&"
import script from "./UserNewArrivalNoticeKeywordTable.vue?vue&type=script&lang=ts&"
export * from "./UserNewArrivalNoticeKeywordTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
